/* import __COLOCATED_TEMPLATE__ from './content-owner.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLSpanElement;
  Args: {
    owner: any;
    updatedAt?: any;
    canEdit?: boolean;
  };
}

const ContentOwner = templateOnlyComponent<Signature>();
export default ContentOwner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Articles::Shared::ContentOwner': typeof ContentOwner;
    'articles/shared/content-owner': typeof ContentOwner;
  }
}
